// extracted by mini-css-extract-plugin
export default {"host":"FeedListDataTags_host__hm2ke","filterButton":"FeedListDataTags_filterButton__l5eoo"};